var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 7C21.0093 6.93032 21.0093 6.85968 20.9998 6.79C20.9911 6.73129 20.9743 6.67407 20.9498 6.62C20.9234 6.57113 20.8933 6.52433 20.8598 6.48C20.8218 6.41675 20.7746 6.35947 20.7198 6.31L20.5998 6.24C20.5421 6.19696 20.478 6.16321 20.4098 6.14H20.2098C20.1489 6.081 20.0777 6.03356 19.9998 6H14.9998C14.4475 6 13.9998 6.44772 13.9998 7C13.9998 7.55228 14.4475 8 14.9998 8H17.8298L13.8298 12.71L9.50981 10.14C9.0871 9.88858 8.54432 9.98187 8.22981 10.36L3.22981 16.36C3.05975 16.5641 2.97788 16.8274 3.00227 17.092C3.02666 17.3565 3.1553 17.6005 3.35981 17.77C3.53972 17.9191 3.76616 18.0005 3.99981 18C4.29724 18.0005 4.57945 17.8685 4.76981 17.64L9.21981 12.3L13.4898 14.86C13.9079 15.108 14.4438 15.0194 14.7598 14.65L18.9998 9.7V12C18.9998 12.5523 19.4475 13 19.9998 13C20.5521 13 20.9998 12.5523 20.9998 12V7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/TrendUp.c91b158e661428afea387abec60950cb.svg";
export { ForwardRef as ReactComponent };